import { makeStyles, Grid, Theme, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    '& *': {
      boxSizing: 'border-box',
    },
  },
  colorGray: {
    color: '#999',
  },
  colorBlack: {
    color: '#000',
  },
  bold: {
    fontWeight: 'bold',
  },
  toolbar: {
    padding: '18px 0 50px 0',
    [theme.breakpoints.down('md')]: {
      padding: '30px 0 30px 0',
    },
  },
  titleContainer: {
    height: '36px',
    '& > p': {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#000',
      display: 'inline-block',
      margin: 0,
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      height: '80px',
    },
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '36px',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
    },
  },

  select: {
    minWidth: '165px',
    margin: '0 12px 0 0',
    [theme.breakpoints.down('md')]: {
      minWidth: '142px',
      margin: '0',
      padding: '0 3px 0 0',
    },
  },
  refreshButton: {
    minWidth: '165px',
    height: '100%',
    border: '1px solid #d5d5d5',
    backgroundColor: '#ffffff',
    borderRadius: 0,
    padding: '0 10px',
    '& > div': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('md')]: {
      minWidth: '142px',
    },
  },

  tableHeader: {
    justifyContent: 'space-between',
    alignItems: 'stretch',
    borderTop: '2px solid #000',
    borderBottom: '1px solid #d5d5d5',
    height: '55px',
    textAlign: 'center',
    '& > div:nth-child(2)': {
      display: 'flex',
    },
    '& > div:last-child': {
      borderWidth: '0',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tableBody: {
    fontSize: '14px',
    margin: '0 0 37px 0',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
  },
  tableRow: {
    justifyContent: 'space-between',
    alignItems: 'stretch',
    height: '96px',
    borderWidth: '0 0 1px 0',
    borderStyle: 'solid',
    borderColor: '#d5d5d5',

    '& > div:last-child': {
      borderWidth: '0',
    },

    '&:hover': {
      backgroundColor: '#f7f7f7',
    },
    [theme.breakpoints.down('md')]: {
      height: '135px',
    },
  },
  tableColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: '0 1px 0 0',
    borderStyle: 'solid',
    borderColor: '#d5d5d5',
    '& > div:last-child': {
      // borderWidth: '0 1px 0 0',
    },
    '& p': {
      padding: 0,
      margin: 0,
    },
    [theme.breakpoints.down('md')]: {
      borderWidth: '0',
    },
  },
  mobileContainer: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      flexGrow: 1,
      padding: '0 14px 0 14px',
      width: 'auto',
    },
  },
  thumbnailColumn: {
    width: '119px',
    '& > span': {
      width: '100px',
    },
    [theme.breakpoints.down('md')]: {
      width: '142px',
      '& > span': {
        width: '100%',
      },
    },
  },
  contentsColumn: {
    width: '295px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
  fileColumn: {
    width: '145px',
    '& > span': {
      textAlign: 'center',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      // flexGrow: 1,
      '& > span': {
        textAlign: 'left',
      },
    },
  },
  dateOfReqeustColumn: {
    width: '95px',
    '& > span': {
      textAlign: 'center',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  dateOfTaskColumn: {
    width: '95px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  statusColumn: {
    width: '85px',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  },
  downloadColumn: {
    width: '60px',
    '& button': {
      border: 'none',
      backgroundColor: 'transparents',
    },
    '& button:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('md')]: {
      width: '15px',
    },
  },
  notDownload: {
    display: 'none',
    // '&:hover': {
    //   cursor: 'not-allowed !important',
    // },
  },

  thumbnail: {
    height: '100%',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  },
  contents: {
    justifyContent: 'flex-start',
    padding: '0 14px 0 14px',
    [theme.breakpoints.down('md')]: {
      padding: '0',
    },
  },
  assetTitle: {
    maxWidth: '295px',
    width: '30vw',
    fontSize: '12px',
  },
  contentsTitle: {
    maxWidth: '295px',
    width: '30vw',
    fontSize: '14px',
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '@keyframes isRefreshing': {
    '0%': {
      transform: 'rotate(360deg)',
    },
    '100%': {
      transform: 'rotate(0deg)',
    },
  },
  isRefreshing: {
    animation: '$isRefreshing 1s linear infinite',
  },
}));
